var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAboutWave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 909.5 200",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 70.4l496.1 116.8c178.2 41.9 362-42.4 413.4-187.2H0"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgOTA5LjUgMjAwIiBmaWxsPSJjdXJyZW50Q29sb3IiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNIDAgNzAuNCBMIDQ5Ni4xIDE4Ny4yIEMgNjc0LjMgMjI5LjEgODU4LjEgMTQ0LjggOTA5LjUgMCBMIDAgMCIvPgo8L3N2Zz4K";
export { SvgAboutWave as ReactComponent };